import React, { Component } from 'react'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import Layout from './layout'
import { FrequentlyAskedQuestions, Home, TermsAndConditions, LinkTo } from './pages'
import './App.css'

export default class App extends Component {
  render () {
    return <Router history={browserHistory}>
      <Route path='/' component={Layout}>
        <IndexRoute component={Home} />
        <Route path='terms-and-conditions' component={TermsAndConditions} />
        <Route path='faq' component={FrequentlyAskedQuestions} />
        <Route path='link-to/*' component={LinkTo} />
        <Route path='link-to' component={LinkTo} />
      </Route>
    </Router>
  }
}



// WEBPACK FOOTER //
// ./src/App.js